import React from 'react';
import { Card, Flex, Text } from '@aws-amplify/ui-react';
import { RatingDefinition } from '../../utils/PlaceDataUtils';
import StarRating from './StarRating';
import { useTranslation } from 'react-i18next';
import './RatingThumbnail.css';

interface RatingThumbnailProps {
    ratings: RatingDefinition[];
}

export default function RatingThumbnail({ ratings }: RatingThumbnailProps) {
    const { t } = useTranslation();

    if (ratings.length === 0) return null;

    const averageRating = Math.round(
        ratings.reduce((acc, curr) => acc + curr.rating, 0) / ratings.length
    );

    return (
        <Card
            className="rating-thumbnail-card"
            variation="elevated"
        >
            <Flex
                direction="column"
                className="rating-thumbnail-content-flex"
            >
                <Text>{t('place.rating.average')}</Text>
                <StarRating
                    rating={averageRating}
                    readOnly={true}
                    size="small"
                />
                <Text>{t(ratings.length === 1 ? 'place.rating.count' : 'place.rating.count_plural', { count: ratings.length })}</Text>
            </Flex>
        </Card>
    );
} 